import { configureStore } from '@reduxjs/toolkit'
import homeSlice from './home/homeSlice'
import commonSlice from './common/commonSlice'
import platformOverviewSlice from './platformOverview/platformOverviewSlice'
import aboutUsSlice from './aboutUs/aboutUsSlice'
import caseStudiesSlice from './caseStudies/caseStudiesSlice'
import contactSlice from './contact/contactSlice'
import riskManagementSlice from './riskManagement/riskManagementSlice'
import multiCurrencyAccountsSlice from './multiCurrencyAccounts/multiCurrencyAccountsSlice'
import whyWorldeskSlice from './whyWorldesk/whyWorldeskSlice'

export default configureStore({
  reducer: {
    home: homeSlice,
    common: commonSlice,
    platformOverview: platformOverviewSlice,
    aboutUs: aboutUsSlice,
    caseStudies: caseStudiesSlice,
    contact: contactSlice,
    riskManagement: riskManagementSlice,
    multiCurrencyAccounts: multiCurrencyAccountsSlice,
    whyWorldesk: whyWorldeskSlice,
  },
})
